import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Brighton() {
  return <CityManagementPage config={allCityConfigs.brighton} />;
}